import BaseService from 'core/api/BaseService';
import { ENV } from 'config/environment';

class MultitrackService extends BaseService {
  constructor() {
    super('/multitracks');
  }

  /** Get all active multitracks (Public) */
  async getMultitracks(queryParams = {}) {
    return this.getAll(queryParams);
  }

  /** Get a single multitrack (Public metadata) */
  async getMultitrack(id) {
    return this.getById(id);
  }

  /** Create a new multitrack */
  async createMultitrack(data) {
    return this.create(data);
  }

  /** Update an existing multitrack */
  async updateMultitrack(id, data) {
    return this.update(id, data);
  }

  /** Delete a multitrack */
  async deleteMultitrack(id) {
    return this.delete(id);
  }

  /** Backend-proxied master mix preview URL (avoids CDN CORS) */
  getPreviewUrl(id) {
    return `${ENV.API_BASE_URL}/multitracks/${id}/preview`;
  }

  /** Backend-proxied individual stem preview URL */
  getStemPreviewUrl(id, stemIndex) {
    return `${ENV.API_BASE_URL}/multitracks/${id}/stems/${stemIndex}/preview`;
  }

  /** Get signed download links for purchased stems */
  async getDownloadLinks(id) {
    return this.get(`${id}/download`);
  }

  /** Get single stem download link */
  async getDownloadLink(id) {
    return this.get(`${id}/download`);
  }
}

export default new MultitrackService();
